<template>
  <div>
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <h1 id="headline" class="page-header">Data Extraction</h1>
    </div>
    <b-alert v-model="showNoDataError" variant="warning" dismissible>
      {{ noDataErrorMessage }}
    </b-alert>
    <b-row>
      <b-col md="5">
        <b-form-group label="Start Date" label-for="start-date">
          <b-form-datepicker
              id="start-date"
              v-model="startDate"
              :max="endDate"
              :disabled="loading"
              placeholder="Select start date"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col md="5">
        <b-form-group label="End Date" label-for="end-date">
          <b-form-datepicker
              id="end-date"
              v-model="endDate"
              :min="startDate"
              :disabled="loading"
              placeholder="Select end date"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group class="mb-0">
          <label class="d-block">&nbsp;</label>
          <b-button
              id="download-button"
              variant="primary"
              :disabled="isDownloadDisabled"
              block
              @click="downloadData"
          >
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            <font-awesome-icon v-else icon="download"/>
            Download
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { dataExtractionApi } from '@/backend'

export default {
  name: 'DataExtraction',
  data () {
    return {
      startDate: null,
      endDate: null,
      loading: false,
      showNoDataError: false,
    }
  },
  computed: {
    isDownloadDisabled () {
      return !this.startDate || !this.endDate || this.loading
    },
    noDataErrorMessage () {
      return `No data found for the selected time frame (${this.startDate} - ${this.endDate}). Please try a different date range.`
    }
  },
  methods: {
    downloadData () {
      this.loading = true
      this.showNoDataError = false

      dataExtractionApi.extractData(this.startDate, this.endDate, (error, data, response) => {
        this.loading = false

        if (error) {
          if (error.status === 404) {
            this.showNoDataError = true
          } else {
            console.error(error)
          }
          return
        }

        const filename = this.extractFilename(response)
        this.downloadBlob(data, filename, 'text/csv')
      })
    },
    extractFilename (response) {
      const defaultFilename = `data-extraction-${this.startDate}-${this.endDate}.csv`
      const contentDisposition = response?.headers?.['content-disposition']
      if (!contentDisposition) {
        return defaultFilename
      }
      const filenameMatch = contentDisposition.match(/filename="(.+)"/)
      return filenameMatch ? filenameMatch[1] : defaultFilename
    },
    downloadBlob (data, filename, mimeType) {
      const blob = new Blob([data], { type: mimeType })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>
